export const IsLocked = ({ field, lockedFields, graphData }) => {
    if (!lockedFields || Object.keys(lockedFields).length === 0) return null;
    const lockedField = lockedFields.find(
      (lockedField) =>
        lockedField.fieldName === field &&
        lockedField.lockedBy !== graphData?.username
    );

    return (
      <div>
        {lockedField ? (
          <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
            {lockedField.lockedBy} is Editing..
          </div>
        ) : null}
      </div>
    );
  };